export default function WristbandIcon({ size = 20, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="8" width="20" height="8" rx="4" />
      <path d="M7 8V6a5 5 0 0 1 10 0v2M7 16v2a5 5 0 0 0 10 0v-2" />
    </svg>
  );
}
